export const MAX_QUESTION_LENGTH = 500
export const MAX_LONG_QUESTION_LENGTH = 500
